module.exports = __webpack_public_path__ + "img/logo400x400.e59e50ec.png";